import type { QuoteBiddingDetailsResponse } from '@views/screens/Quote/data-provider/quote-bidding-details/api';

export const normalizeQuoteBiddingDetails = (data: QuoteBiddingDetailsResponse) => {
  if (!data) {
    return [];
  }
  return data;
};
